export const config = {
  imgUrl: process.env.REACT_APP_IMG_URL,
  locale: 'ru' as 'tj' | 'ru',
  yearNow: new Date(Date.now()).getFullYear(),
}
